import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import MTNLogo from "../../../../assets/logo/JPEG/MTN_2022_Logo_Black_RGB.jpg";

/** Robust, TZ-safe deadline formatter */
function formatDeadline(rawDeadline) {
  if (!rawDeadline) return "Deadline not specified";

  // Try to parse normally
  let d = new Date(rawDeadline);

  // If parsing failed OR the input looks like "YYYY-MM-DD" (date-only),
  // create a date from just the calendar day to avoid local offsets.
  if (isNaN(d.getTime())) {
    const datePart = String(rawDeadline).slice(0, 10); // "YYYY-MM-DD"
    const [y, m, dd] = datePart.split("-").map(Number);
    if (y && m && dd) d = new Date(Date.UTC(y, m - 1, dd, 0, 0, 0));
  }

  if (isNaN(d.getTime())) return "Deadline not specified";

  // Force display in Rwanda time to prevent +1 day from UTC timestamps
  const label = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Africa/Kigali",
  }).format(d);

  return `Deadline: ${label}`;
}

const JobCard = ({ job }) => {
  const navigate = useNavigate();
  if (!job) return null;

  const {
    id,
    jobId,
    _id,
    positionTitle,
    region,
    jobTitle,
    city,
    department,
    departmentName,
    unit,

    // real field from backend:
    applicationDeadline,
    // fallbacks the API might use
    applicationdeadline,
    application_deadline,
    closingDate,
    deadlineDate,
    deadline,
  } = job;

  const resolvedId = id || jobId || _id;

  const handleViewDetails = () => {
    if (!resolvedId) {
      console.error("No valid job ID found:", job);
      return;
    }
    navigate(`/jobs/${resolvedId}`);
  };

  // Prefer the canonical backend field but accept known aliases
  const rawDeadline =
    applicationDeadline ??
    applicationdeadline ??
    application_deadline ??
    closingDate ??
    deadlineDate ??
    deadline ??
    null;

  const formattedDeadline = formatDeadline(rawDeadline);
  const resolvedDepartment =
    department || departmentName || unit || "Department not specified";

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-gradient-to-r from-white via-gray-100 to-gray-200 rounded-lg p-4 w-full min-h-[120px] overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
      <div className="flex flex-col sm:flex-row items-center w-full">
        <div className="flex items-center justify-center w-full sm:w-auto bg-white px-4 py-2 sm:py-0">
          <img
            src={MTNLogo}
            alt="Company Logo"
            className="h-16 sm:h-20 w-auto object-contain"
          />
        </div>

        <div className="hidden sm:block w-px h-3/4 bg-gray-300 mx-4"></div>

        <div className="flex flex-col justify-center text-center sm:text-left mt-3 sm:mt-0">
          <h3 className="font-semibold text-gray-900 text-lg mb-1">
            {positionTitle || "Software Tester"}
          </h3>
          <p className="text-gray-600 text-sm mb-1">
            MTN Rwanda • {resolvedDepartment} • {city || "Kigali"},{" "}
            {region || "Rwanda"}
          </p>

          <div className="flex flex-col sm:flex-row items-center sm:gap-4 text-sm text-gray-700">
            <span>{jobTitle || "Permanent"}</span>
            <span className="flex items-center gap-1">
              <FaCalendarAlt className="text-yellow-500" />
              {formattedDeadline}
            </span>
          </div>
        </div>
      </div>
      <button
        onClick={handleViewDetails}
        className="mt-4 sm:mt-0 bg-[#FFCC00] hover:bg-yellow-500 text-gray-900 font-medium text-sm px-5 py-2 rounded-full transition-all duration-150 shadow-sm hover:shadow-md w-full sm:w-auto"
      >
        Job Details
      </button>
    </div>
  );
};

export default JobCard;
